class FlixProductMedia extends HTMLElement {
  connectedCallback() {
    this._wrap = this.querySelector('[data-flix-tilt-wrap]');
    this._card = this.querySelector('[data-flix-tilt-card]');
    if (this._wrap && this._card) {
      this._onMove = this._onMove.bind(this);
      this._onLeave = this._onLeave.bind(this);
      this._wrap.addEventListener('mousemove', this._onMove);
      this._wrap.addEventListener('mouseleave', this._onLeave);
    }

    this._slot = this.querySelector('[data-flix-media-slot]');
    const zoomBtn = this.querySelector('[data-flix-media-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', () => this._openZoom());

    this.querySelectorAll('[data-flix-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => this._selectThumb(thumb));
    });
  }

  _onMove(e) {
    const r = this._wrap.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    this._card.style.transform = 'rotateY(' + (x * 16) + 'deg) rotateX(' + (-y * 16) + 'deg)';
  }

  _onLeave() {
    this._card.style.transform = 'rotateY(0deg) rotateX(0deg)';
  }

  _selectThumb(thumb) {
    this.querySelectorAll('[data-flix-thumb]').forEach((t) => { t.style.borderColor = 'var(--border)'; });
    thumb.style.borderColor = 'var(--borderHi)';
    if (!this._slot) return;

    const isVideo = thumb.dataset.isVideo === 'true';
    this._slot.dataset.isVideo = isVideo ? 'true' : 'false';
    this._slot.dataset.mediaId = thumb.dataset.mediaId;
    this._slot.dataset.largeUrl = thumb.dataset.imageUrl;
    const img = this._slot.querySelector('img');
    if (img) img.src = thumb.dataset.imageUrl;
    if (this._card && thumb.dataset.aspectRatio) this._card.style.aspectRatio = thumb.dataset.aspectRatio;
    // Inline style strings baked in by Liquid (e.g. "display:flex;...;display:none")
    // collapse to one value when parsed, so restoring visibility needs an
    // explicit value here rather than clearing back to a fallback.
    this.querySelectorAll('[data-flix-play-overlay]').forEach((el) => {
      el.style.display = isVideo ? 'flex' : 'none';
    });
  }

  _openZoom() {
    if (!this._slot) return;
    if (this._slot.dataset.isVideo === 'true') {
      const template = this.querySelector('[data-flix-media-embed="' + this._slot.dataset.mediaId + '"]');
      if (!template) return;
      document.dispatchEvent(new CustomEvent('flix:lightbox:open', { detail: { html: template.innerHTML } }));
    } else {
      const img = this._slot.querySelector('img');
      document.dispatchEvent(new CustomEvent('flix:lightbox:open', {
        detail: { imageUrl: this._slot.dataset.largeUrl, alt: img ? img.alt : '' }
      }));
    }
  }
}
customElements.define('flix-product-media', FlixProductMedia);
